const purchaseStatusForSelection = [
	'Created',
	'ConfirmInProgress',
	'Confirmed',
	'Committed',
	'Completed',
	'Cancelled',
	'Expired',
	'Failed',
].map(key => {
	return { id: key, name: key };
});

export { purchaseStatusForSelection };
